/**
 * Resolve App readiness evidence display for a System wizard step.
 * Manual wizard ticks remain separate from App-verified status.
 */

export function wizardStepEvidence(evidenceGate, stepCode) {
  if (!evidenceGate || !stepCode) {
    return null;
  }
  const map = evidenceGate.wizard_steps || {};
  return map[stepCode] || null;
}

export function evidenceStatusLabelKey(status) {
  const normalized = String(status || '').toLowerCase();
  const known = [
    'completed',
    'incomplete',
    'unknown',
    'stale',
    'missing',
    'legacy',
    'activation_pending',
    'not_applicable',
    'skipped',
  ];
  if (known.includes(normalized)) {
    return `setupWizard:tenant_tab.evidence_status.${normalized}`;
  }
  return 'setupWizard:tenant_tab.evidence_status.unknown';
}

export function formatEvidenceObservedAt(row, reportedAt) {
  if (row?.observed_at) {
    return row.observed_at;
  }
  if (Array.isArray(row?.app_steps)) {
    const first = row.app_steps.find((s) => s?.observed_at);
    if (first?.observed_at) {
      return first.observed_at;
    }
  }
  return reportedAt || null;
}
